import { useEffect, useState, CSSProperties, useMemo } from "react"
import API from "./API"
import { AdminQueryActivity } from "../../backend/src/api/dto"
import { Link } from "react-router"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { DndContext, KeyboardSensor, MouseSensor, TouchSensor, closestCenter, type DragEndEvent, type UniqueIdentifier, useSensor, useSensors } from '@dnd-kit/core'
import { restrictToVerticalAxis } from '@dnd-kit/modifiers'
import { arrayMove, SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

function Activities() {

    const [data, setData] = useState<AdminQueryActivity[]>([])

    useEffect(() => {
        API.getActivities().then(res => {
            setData(res)
        })
    }, [])

    function handleDragEnd(event: DragEndEvent) {
        const { active, over } = event
        console.log({ active, over });
        if (active && over && active.id !== over.id) {
            setData(data => {
                const oldIndex = data.findIndex(item => 'activity-' + item.activityId === active.id)
                const newIndex = data.findIndex(item => 'activity-' + item.activityId === over.id)
                const newArray = arrayMove(data, oldIndex, newIndex);
                API.sortOrder('activity',newArray.map(item => item.activityId));
                return newArray
            })
        }
    }

    const sensors = useSensors(
        useSensor(MouseSensor, {}),
        useSensor(TouchSensor, {}),
        useSensor(KeyboardSensor, {})
    )

    const dataIds = useMemo<UniqueIdentifier[]>(
        () => data?.map(({ activityId }) => 'activity-' + activityId),
        [data]
    );

    return (
        <div className="p-3">
            <div className="card">
                <div className="card-header" style={{ height: '55px' }}>
                    <div className="row">
                        <div className="col-6">
                            <h5 className="mt-2">
                                <FontAwesomeIcon fixedWidth icon={["fas", "chart-line"]} /> Aktivity
                            </h5>
                        </div>
                        <div className="col-6 text-end">
                            <Link to="/dashboard/activity/0" className="btn btn-success"><FontAwesomeIcon fixedWidth icon={["fas", "plus"]} /> Pridať aktivitu</Link>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <DndContext collisionDetection={closestCenter} modifiers={[restrictToVerticalAxis]} onDragEnd={handleDragEnd} sensors={sensors}>
                        <table className="table table-bordered table-hover">
                            <thead>
                                <tr>
                                    <th style={{ width: '50px' }}></th>
                                    <th style={{ width: '300px' }}>Meno</th>
                                    <th>Popis</th>
                                    <th className="text-center" style={{ width: '110px' }}>Stav</th>
                                    <th className="text-center" style={{ width: '110px' }}>Akcia</th>
                                </tr>
                            </thead>
                            <tbody>
                                <SortableContext items={dataIds} strategy={verticalListSortingStrategy}>
                                    {
                                        data.map(activity => {
                                            return (
                                                <DraggableRow key={'activity-' + activity.activityId} activity={activity} />
                                            )
                                        })
                                    }
                                </SortableContext>
                            </tbody>
                        </table>
                    </DndContext>
                </div>
            </div>
        </div>
    )
}




function DraggableRow({ activity }: { activity: AdminQueryActivity }) {
    const { transform, transition, setNodeRef, isDragging, attributes, listeners  } = useSortable({
        id: 'activity-' + activity.activityId,
    })

    const style: CSSProperties = {
        transform: CSS.Transform.toString(transform),
        transition: transition,
        opacity: isDragging ? 0.8 : 1,
        zIndex: isDragging ? 1 : 0,
        position: 'relative',
    }
    return (
        <tr ref={setNodeRef} style={style}>
            <td className="text-center">
                <div {...attributes} {...listeners}>
                    <FontAwesomeIcon fixedWidth icon={["fas", "grip-vertical"]} />
                    </div>
            </td>
            <td>{activity.name}</td>
            <td>{activity.description}</td>
            <td className="text-center">{activity.status ? <span className="text-success">Aktívna</span> : <span className="text-danger">Neaktívna</span>}</td>
            <td className="text-center"><Link className="btn btn-primary btn-sm" to={"/dashboard/activity/" + activity.activityId}><FontAwesomeIcon fixedWidth icon={["fas", "pen"]} /> Upraviť</Link></td>
        </tr>

    )
}



export default Activities